import React, {memo} from 'react';
import cx from 'classnames';

import style from './SimilarBrandAndSubcategory.scss';

const SimilarBrandAndSubcategory = memo(({
  similarLists,
  title = 'Popüler Aramalar',
  hasBorder
}) => {
  if (similarLists?.[0]?.length || similarLists?.[1]?.length) {
    return (
      <div id='similarBrandAndSubCategoryLinks' className={cx(style.container, hasBorder && style.bordered)}>
        <h6 className={style.title}>{title}</h6>
        {similarLists?.map((list, index) =>
          list?.length !== 0 && <ul data-test-id='similar-keyword-items' key={index} className={style.list}>
            {list?.map((item, index) => (
              <li key={item?.id}>
                <a href={item?.href} className={style.link}>
                  {item?.displayName}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  return null
});

export default SimilarBrandAndSubcategory;
